import { useEvent } from '@tribeplatform/react-sdk/hooks'
import { Card } from '@tribeplatform/react-ui-kit/Card'

import { ErrorBoundary } from '../common/components/ErrorBoundary/ErrorBoundary.js'

import { EventsListFeedViewItemBox } from './List/components/FeedView/ItemBox.js'
import { EventItemWrapper } from './List/components/ItemWrapper.js'
import { EventStaticFieldIds } from './List/types.js'

interface Props {
  id: string
  interactive?: boolean
}

export const EventNodeComponent = ({ id, interactive = true }: Props) => {
  const { data: event, isLoading } = useEvent({
    variables: { id },
  })

  if (isLoading) {
    return <EventLoadingState />
  }

  if (!event) {
    return null
  }

  return (
    <ErrorBoundary>
      <div className="relative w-full">
        {!interactive && (
          <div className="w-full h-full absolute top-0 left-0 bg-transparent z-10" />
        )}
        <div className="not-prose bg-surface-subdued rounded-base">
          <EventItemWrapper event={event}>
            <EventsListFeedViewItemBox
              event={event}
              visibleFieldIds={{
                [EventStaticFieldIds.CoverImage]: true,
                [EventStaticFieldIds.EventDetails]: true,
                [EventStaticFieldIds.HostInfo]: true,
              }}
            />
          </EventItemWrapper>
        </div>
      </div>
    </ErrorBoundary>
  )
}

export const EventLoadingState = () => (
  <Card padding="none">
    <Card.Content>
      <div className="flex space-s-4 items-center border rounded-xl p-3 bg-action-neutral ">
        <div className="h-24 w-24 bg-skeleton rounded-sm" />
        <div className="grow space-y-4 py-1">
          <div className="h-4 bg-skeleton rounded-full w-1/2" />
          <div className="space-y-2">
            <div className="h-4 bg-skeleton rounded-full w-5/6" />
          </div>
          <div className="h-4 bg-skeleton rounded-full w-1/2" />
        </div>
      </div>
    </Card.Content>
  </Card>
)
